module.exports = __webpack_public_path__ + "static/media/process-flow-4-icon.37637aa0.svg";